module.exports = __webpack_public_path__ + "img/l12.6ae72894.png";